import React from "react";
import "../style/style.scss";

interface StepIndicatorProps {
  number: number;
  label: string;
  className?: string;
}

const StepIndicator: React.FC<StepIndicatorProps> = ({ number, label, className = "" }) => {
  return (
    <div className={`step flex-center-center ${className}`}>
      <b>{number}</b>
      <span>{label}</span>
    </div>
  );
};

export default StepIndicator;
